import type { ScoreSummary } from '@corocanto/scoring';
import { useTranslation } from 'react-i18next';
import { VOICE_PARTS } from '@corocanto/scoring';
import ui from '../styles/ui.module.css';

export type Grade = 'READY' | 'ALMOST' | 'NEEDS_WORK';

const GRADE_CLASS: Record<Grade, string | undefined> = {
  READY: ui.chipReady,
  ALMOST: ui.chipAlmost,
  NEEDS_WORK: ui.chipNeedsWork,
};

/** Hazır / Neredeyse / Çalışmalı, or "Henüz yok" when there is no grade. */
export function GradeChip({ grade }: { grade: Grade | null }) {
  const { t } = useTranslation();
  const className = grade ? GRADE_CLASS[grade] : ui.chipNone;
  return <span className={`${ui.chip} ${className}`}>{t(grade ? `grades.${grade}` : 'grades.none')}</span>;
}

/** The voice parts found in a song, plus "Eşlik" when it has accompaniment. */
export function PartChips({ summary }: { summary: ScoreSummary }) {
  const { t } = useTranslation();
  const present = new Set(summary.parts.map((p) => p.voicePart).filter((p) => p !== null));
  const hasAccompaniment = summary.parts.some((p) => p.role === 'accompaniment');
  return (
    <span className={ui.chipRow}>
      {VOICE_PARTS.filter((p) => present.has(p)).map((p) => (
        <span key={p} className={`${ui.chip} ${ui.chipSoft}`} title={t(`parts.${p}`)}>
          {t(`parts.${p}`)}
        </span>
      ))}
      {hasAccompaniment && <span className={`${ui.chip} ${ui.chipNeutral}`}>{t('parts.accompaniment')}</span>}
    </span>
  );
}
